<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="W1" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9kshvn0gjj318g0p0dk4.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g9kshyh6eaj318g0p00v5.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9ksi1od97j318g0p0q7l.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9ksi4ypbij318g0p00v7.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9ksi8ibkaj318g0p0tas.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9ksiguw4qj318g0p0jxw.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9ksik1rg9j318g0p079x.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g9ksinho06j318g0p0dkg.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9ksiqwz3xj318g0p078u.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1g9ksiu1ig5j318g0p042k.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9ksbsu7o8j30ku112jvj.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9ksbycqkmj30ku112abx.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9ksc2otvgj30ku1120uq.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kscmma98j30ku112aeb.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g9ksca3c5lj30ku112mz1.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9ksd7dahjj30ku112jwo.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1g9ksdffgvhj30ku11277w.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g9ksdlwyznj30ku112q6v.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g9ksdqz0j5j30ku112wij.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9ksdv7fhyj30ku112ju8.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
           
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    }
}
</script>
<style scoped>

.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_1.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_2.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/W/w1.vue